/**
 * Validate is card number passed is Visa, MasterCard or American Express
 *
 * @param cardNumber - card number
 */

const validateCardNumber = (cardNumber: string): boolean => {
  if (/^(2|4|5)/.test(cardNumber)) {
    return /^(\d{4}\s){3}\d{4}$/.test(cardNumber);
  }

  if (/^(37|34)/.test(cardNumber)) {
    return /^\d{4}\s\d{6}\s\d{5}$/.test(cardNumber);
  }

  return false;
};

export default validateCardNumber;
